import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";

import "swiper/css";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";

import img1 from "../../../assets/img/landingPageThree/sectionSix/card1.webp";
import img2 from "../../../assets/img/landingPageThree/sectionSix/card2.webp";
import img3 from "../../../assets/img/landingPageThree/sectionSix/card3.webp";
import img4 from "../../../assets/img/landingPageThree/sectionSix/card4.webp";
import img5 from "../../../assets/img/landingPageThree/sectionSix/card5.webp";
import img6 from "../../../assets/img/landingPageThree/sectionSix/card6.webp";
import img7 from "../../../assets/img/landingPageThree/sectionSix/card7.webp";
import img8 from "../../../assets/img/landingPageThree/sectionSix/card8.webp";
import img9 from "../../../assets/img/landingPageThree/sectionSix/card9.webp";
import img10 from "../../../assets/img/landingPageThree/sectionSix/card10.webp";
import img11 from "../../../assets/img/landingPageThree/sectionSix/card11.webp";
import img12 from "../../../assets/img/landingPageThree/sectionSix/card12.webp";
import img13 from "../../../assets/img/landingPageThree/sectionSix/card13.webp";
import img14 from "../../../assets/img/landingPageThree/sectionSix/card14.webp";
import img15 from "../../../assets/img/landingPageThree/sectionSix/card15.webp";
import img16 from "../../../assets/img/landingPageThree/sectionSix/card16.webp";
import img17 from "../../../assets/img/landingPageThree/sectionSix/card17.webp";
import img18 from "../../../assets/img/landingPageThree/sectionSix/card18.webp";
import img19 from "../../../assets/img/landingPageThree/sectionSix/card19.webp";
import img20 from "../../../assets/img/landingPageThree/sectionSix/card20.webp";
import img21 from "../../../assets/img/landingPageThree/sectionSix/card21.webp";
import img22 from "../../../assets/img/landingPageThree/sectionSix/card22.webp";
import { CTooltip } from "@coreui/react-pro";

const row1 = [
  { className: "card1",  i18nKey: "cert_sassmaq",  img: img1  },
  { className: "card2",  i18nKey: "cert_atuacao",  img: img2  },
  { className: "card3",  i18nKey: "cert_iso9001",  img: img3  },
  { className: "card4",  i18nKey: "cert_iso14001", img: img4  },
  { className: "card5",  i18nKey: "cert_iso45001", img: img5  },
  { className: "card6",  i18nKey: "cert_licenca",  img: img6  },
  { className: "card7",  i18nKey: "cert_letpp",    img: img7  },
  { className: "card8",  i18nKey: "cert_lac",      img: img8  },
  { className: "card9",  i18nKey: "cert_cr",       img: img9  },
  { className: "card10", i18nKey: "cert_anvisa",   img: img10 },
  { className: "card11", i18nKey: "cert_pf",       img: img11 },
];

const row2 = [
  { className: "card12", i18nKey: "cert_exercito", img: img12 },
  { className: "card13", i18nKey: "cert_mapa",      img: img13 },
  { className: "card14", i18nKey: "cert_olhovivo",  img: img14 },
  /* { className: "card15", i18nKey: "cert_gpmh",      img: img15 }, */
  { className: "card16", i18nKey: "cert_laco",      img: img16 },
  { className: "card17", i18nKey: "cert_namao",     img: img17 },
  { className: "card18", i18nKey: "cert_pellets",   img: img18 },
  { className: "card19", i18nKey: "cert_plvb",      img: img19 },
  { className: "card20", i18nKey: "cert_plvb_ouro", img: img20 },
  { className: "card21", i18nKey: "cert_tfs",       img: img21 },
  { className: "card22", i18nKey: "cert_ecovadis",  img: img22 },
];

const breakpoints = {
  1400: {
    slidesPerView: 8,
  },
  1200:{
    slidesPerView: 8,
  },
  900: {
    slidesPerView: 6,
  },
  700: {
    slidesPerView: 4,
  },
  0: {
    slidesPerView: 2,
  },
};

function SectionSix() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="licenses" className={`sectionSix ${isVisible ? "visible" : ""}`}>
        <div className="sectionSixTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp4_certs_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("lp4_certs_text")}
          </p>
        </div>
        <Swiper
          slidesPerView={8}
          spaceBetween={0}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          speed={500}
          loop={true}
          modules={[Autoplay, Navigation]}
          breakpoints={breakpoints}
          className={`mt-5 ${isVisible ? "visible" : ""}`}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {row1.map(({ className, i18nKey, img }) => (
            <SwiperSlide key={className}>
              <div className={`${className} card ${isVisible ? "visible" : ""}`}>
                <CTooltip content={t(i18nKey)} placement="bottom">
                  <img src={img} alt="" />
                </CTooltip>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
        <Swiper
          slidesPerView={8}
          spaceBetween={0}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          speed={500}
          loop={true}
          modules={[Autoplay, Navigation]}
          breakpoints={breakpoints}
          className={`${isVisible ? "visible" : ""}`}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {row2.map(({ className, i18nKey, img }) => (
            <SwiperSlide key={className}>
              <div className={`${className} card ${isVisible ? "visible" : ""}`}>
                <CTooltip content={t(i18nKey)} placement="bottom">
                  <img src={img} alt="" />
                </CTooltip>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}

export default SectionSix;
